var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExcelIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2335 0H4.28464C3.55234 0 2.95728 0.599733 2.95728 1.3416V22.6584C2.95728 23.3995 3.55234 24 4.28464 24H20.2164C20.9503 24 21.5438 23.3995 21.5438 22.6584V5.3664L16.2335 0ZM16.2335 1.8968L19.667 5.3664H16.2335V1.8968ZM20.2167 22.6584H4.28464V1.3416H14.9059V5.3664C14.9059 6.10747 15.4997 6.708 16.2333 6.708H20.2164L20.2167 22.6584Z",
    fill: "#218850"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 4.125,
    width: 12.75,
    height: 15.75,
    rx: 1,
    fill: "#218850"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7688 9H4.74976L6.7688 12.1475L4.74976 15.2951H6.7688L7.79737 13.7213L8.82595 15.2951H10.845L8.82595 12.1475L10.845 9H8.82595L7.79737 10.5738L6.7688 9Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExcelIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/excel-icon.cb17a5273a06bfa8a6b0661ca45dca1e.svg";